import { render, staticRenderFns } from "./inventory-list.vue?vue&type=template&id=10777962&"
import script from "./inventory-list.vue?vue&type=script&lang=js&"
export * from "./inventory-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports